import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAllGraphNames } from './api';

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [graphNames, setGraphNames] = useState([]);
    const [currentSelectedNode, setCurrentSelectedNode] = useState(null);
    const [newData, setNewData] = useState(null);
    const [onReload, setOnReload] = useState(false);


    useEffect(() => {
        getAllGraphNames().then((names) => {
            setGraphNames(names);
        });
    }, []);

    const value = {
        isLoading,
        setIsLoading,
        data,
        setData,
        graphNames,
        setGraphNames,
        currentSelectedNode,
        setCurrentSelectedNode,
        newData,
        setNewData,
        onReload,
        setOnReload
    };

    return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
